export { default } from "./useCanAccessStandardsAlignmentReport";
